import * as Yup from 'yup';

const Validation = Yup.object({
    category_name: Yup.string().required("Required"),
});

export default Validation;
